// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdownMenu{padding:15px !important;width:\"200px\"}.dropdownMenu .ant-divider-horizontal{margin:12px !important;min-width:auto;width:auto}.dropdownMenu .menuItemTitle{font-weight:600;font-family:\"Ubuntu Mono\",\"IBM Plex Mono\",\"Roboto Mono\",\"Cutive Mono\",monospace}.headerDiv{text-align:center}.headerDiv>a{color:#96ae09;font-size:12px}.opacityText{opacity:.5;font-size:12px;text-align:center}.opacityText>a{color:#96ae09}", ""]);
// Exports
module.exports = exports;
